export enum ErrorContext {
    CREATE_FOLDER = 'CreateFolder',
    ORGANIZATION_FORM = 'OrganizationForm',
    SENDER_FORM = 'SenderForm',
    MOVE_MESSAGES = 'MoveMessages',
    TRASH_MESSAGES = 'TrashMessages',
    USERS_SCREEN = 'UsersScreen',
    UPDATE_FOLDER = 'UpdateFolder',
    UPDATE_FOLDER_MOVE = 'UpdateFolderMove',
    DELETE_FOLDER = 'DeleteFolder',
    UNVERIFY_EMAIL = 'UnverifyEmail',
    VERIFY_MOBILE = 'VerifyMobile',
    MAIL_INFORMATION = 'Information',
    MAILITEM = 'MailItem',
    ADD_NOTE = 'AddNote',
    UPDATE_MESSAGE = 'UpdateMessage',
}
